<template>
  <a-modal
    title="操作"
    :width="500"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item
        label="数据图编号"
        :labelCol="{lg: {span: 8}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 12}, sm: {span: 10} }"
      >
        <span style="margin-left:10px">{{ `${id}` }}</span>
      </a-form-item>
      <a-form-item
        label="标注者帐号"
        :labelCol="{lg: {span: 8}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 13}, sm: {span: 10} }"
      >
        <select-project-user v-if="visible" v-decorator="[ 'user', {rules: [{ required: true, message: '未指定标注用户'}]} ]" style="margin-left:10px" ref="members"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { assignTask } from '@/api/data'
import SelectProjectUser from '@/components/selector/SelectProjectUser'
export default {
  name: 'DispatchDataModal',
  components: {
    SelectProjectUser
  },
  data () {
    this.lastFetchId = 0
    // this.handleChange = debounce(this.handleChange, 300);
    return {
      id: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
    console.log('form::', this.form)
  },

  methods: {
    add (id) {
      this.id = id
      this.visible = true
    },
    close () {
      this.$emit('close')
      this.visible = false
      this.$refs.members.selectedUser = { isNull: true }
    },
    handleOk () {
      const _this = this
      debugger
      if (this.$refs.members.selectedUser.isNull == false) this.form.setFieldsValue({ user: 'true' })
      this.form.validateFields((err, values) => {
        var data = {
          data_id: this.id,
          user_uid: this.$refs.members.selectedUser.uid
        }
        assignTask(data).then(res => {
          _this.$message.success('分配成功')
          _this.$emit('dataChanged')
        }).catch(() => {
          _this.$message.error('分配失败')
        }).finally(() => {
          _this.close()
        })
        if (this.values.length > 0) this.handleOk()
      })
    },
    handleCancel () {
      this.close()
    }
  }
}
</script>
